import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { IAdversiting } from '@core/models';
import { Page } from '@core/services';
import { CdnUrlPipe } from '@shared/pipes';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { lastValueFrom } from 'rxjs';

/**
 * ### **AdversitingComponent**
 *
 * **Selector:** ``<app-adversiting>``
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar los avisos publicitarios que aparecen en la app web.
 */
@Component({
  selector: 'app-adversiting',
  imports: [LazyLoadImageModule, CdnUrlPipe],
  templateUrl: "./adversiting.component.html",
  styleUrl: "./adversiting.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Adversiting implements OnInit {
  private readonly pageService = inject(Page);

  /** Variable que guardará el slug o texto representativo que servirá para obtener los avisos publicitarios.*/
  readonly slug = input.required<string>();
  /** Variable que guardara la lista de avisos publicitaros*/
  protected readonly adversitings = signal<IAdversiting[]>([]);
  /** @ignore*/
  constructor() {}

  /**Función nativa de angular que se activa una vez ha se ha cargado el contructor, en este caso ejecuta o llama
   * al método getAdversitings() */
  ngOnInit() {
    this.getAdversitings();
  }

  /**
   *  obtiene los banners publicitarios según el slug asociado.
   */
  private async getAdversitings(): Promise<void> {
    try {
      const response = await lastValueFrom(this.pageService.advertising(this.slug()));
      if (response) {
        this.adversitings.set(response);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
